// @flow

import { type Receipt } from '@tectonics/prs/receipts';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';

export const egyptFinalReceiptStrategy = {
  shouldUse(incomingPayment: IncomingPayment, _receipt: Receipt): boolean {
    return incomingPayment.country === 'eg';
  },
  execute(_incomingPayment: IncomingPayment, receipt: Receipt): Receipt {
    const localAmount = receipt.amount_local_base[1];
    return {
      ...receipt,
      amount_ext: ['EGP', localAmount],
    };
  },
};
